<template>
    <div class="import-contacts-modal">
        <common-content-wrapper width="medium">
            <common-content-spacer height="tiny">
                <div class="import-contacts-modal__text-align-center">
                    <p v-if="loadingContacts" class="import-contacts-modal__text-align-center">
                        {{ $t('modals.import_contacts_modal.loading') }}
                    </p>
                    <span v-if="!loadingContacts">
                        {{ $t('modals.import_contacts_modal.label.import') }}
                    </span>
                </div>
                <common-content-spacer height="medium">
                    <div class="import-contacts-modal__button-container">
                        <div class="import-contacts-modal__signin-wrapper" @click="collectGoogleContacts">
                            <div class="import-contacts-modal__signin-spacearound">
                                <div class="import-contacts-modal__signin-button">
                                    <div class="import-contacts-modal__signin-logo">
                                        <common-icon name="google-transparent" size="large"></common-icon>
                                    </div>
                                    <div class="import-contacts-modal__signin-label import-contacts-modal__google-label">
                                        {{ $t('modals.import_contacts_modal.buttons.sign_in_with', { api: 'Google' }) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="import-contacts-modal__signin-wrapper" @click="collectMicrosoftContacts">
                            <div class="import-contacts-modal__signin-spacearound">
                                <div class="import-contacts-modal__signin-button">
                                    <div class="import-contacts-modal__signin-logo import-contacts-modal__microsoft-logo">
                                        <common-icon name="microsoft-logo" size="medium"></common-icon>
                                    </div>
                                    <div class="import-contacts-modal__signin-label">
                                        {{ $t('modals.import_contacts_modal.buttons.sign_in_with', { api: 'Microsoft' }) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <common-divider>
                        <p class="import-contacts-modal__text-align-center">
                            {{ $t('modals.import_contacts_modal.label.invite') }}
                        </p>
                    </common-divider>
                    <common-content-wrapper width="small">
                        <common-warning v-if="showWarning" size="medium" :text="warningMessage"></common-warning>
                    </common-content-wrapper>
                </common-content-spacer>
            </common-content-spacer>
            <contact-collector
                :showContactCollector="showContactCollector"
                :showAsInnerModal="showAsInnerModal"
                :buttonLabel="sendButtonLabel"
                :prefillUser="prefillUser"
                :showSearchBar="showSearchBar"
                :maxSelectedContacts="maxSelectedContacts"
                :contactsProp="contacts"
                @selected-contacts="collectContacts"
                @close="closeContactCollector"
            ></contact-collector>
        </common-content-wrapper>
    </div>
</template>
<script>
    import ContactCollector from './ContactCollector'
    import MicrosoftAPI from 'api/MicrosoftAPI'
    import GoogleAPI from 'api/GoogleAPI'

    export default {
        components: {
            ContactCollector,
        },
        props: {
            showAsInnerModal: { type: Boolean, required: false, default: false },
            sendButtonLabel: { type: String, required: false, default: 'Send' },
            prefillUser: { type: String, required: false, default: '' },
            showSearchBar: { type: Boolean, required: false, default: true },
            maxSelectedContacts: { type: Number, required: false, default: 0 },
        },
        data() {
            return {
                contacts: [],
                showContactCollector: false,
                loadingContacts: false,
                showWarning: false,
                warningMessage: '',
            }
        },
        methods: {
            closeContactCollector() {
                this.showContactCollector = false
            },

            collectMicrosoftContacts() {
                this.loadingContacts = true
                return MicrosoftAPI.getOutlookContacts()
                    .then((response) => this.showAllUserContacts(response.value, 'microsoft'))
                    .catch(() => {
                        this.loadingContacts = false
                    })
            },
            collectGoogleContacts() {
                this.loadingContacts = true
                return GoogleAPI.getGoogleContacts()
                    .then((response) => {
                        this.showAllUserContacts(response.result.connections, 'google')
                    })
                    .catch(() => {
                        this.loadingContacts = false
                    })
            },

            collectContacts(ev) {
                this.emitEvent({ name: 'contacts-emails-collected', payload: ev })
                this.closeContactCollector()
            },

            async showAllUserContacts(allUsersConnections, api) {
                this.contacts = []
                let addresses = []
                if (!allUsersConnections || allUsersConnections.length === 0) {
                    this.warningMessage = this.$t('modals.import_contacts_modal.warning_messages.no_contacts', {
                        emailProvider: api,
                    })
                    this.showWarning = true
                    this.loadingContacts = false
                    api === 'google' ? GoogleAPI.googleLogout() : MicrosoftAPI.clearLocal()
                    return
                } else {
                    this.showWarning = false
                }
                for (const user of allUsersConnections) {
                    if (!user.emailAddresses) continue
                    user.emailAddresses.forEach((element, i) => {
                        user.emailAddresses[i].selected = false
                    })
                    switch (api) {
                        case 'google':
                            addresses = user.emailAddresses.map((e) => {
                                return {
                                    email: e.value,
                                    selected: false,
                                }
                            })
                            this.contacts.push({
                                name: user.names[0].displayName,
                                firstName: user.names[0].givenName,
                                lastName: user.names[0].familyName,
                                emails: addresses,
                                image: user.photos[0].url,
                            })
                            GoogleAPI.googleLogout()
                            break

                        case 'microsoft':
                            addresses = user.emailAddresses.map((e) => {
                                return {
                                    email: e.address,
                                    selected: false,
                                }
                            })

                            this.contacts.push({
                                name: user.displayName,
                                firstName: user.givenName,
                                lastName: user.surname,
                                emails: addresses,
                                image: await MicrosoftAPI.getOutlookContactPhoto(user.id, user.emailAddresses[0].address),
                            })
                            MicrosoftAPI.clearLocal()
                            break

                        default:
                            throw new Error('Unsupported API')
                    }
                }
                this.loadingContacts = false
                if (!this.contacts.length) {
                    this.warningMessage = this.$t('modals.import_contacts_modal.warning_messages.no_contact_emails')
                    this.showWarning = true
                    api === 'google' ? GoogleAPI.googleLogout() : MicrosoftAPI.clearLocal()
                    return
                }
                this.showContactCollector = true
            },
        },
        mounted() {
            MicrosoftAPI.configure()
            GoogleAPI.configure()
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/page-elements/invites/_import-contacts-modal.scss';
</style>
